import React from 'react';
import compose from 'recompose/compose';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Picker } from 'emoji-mart';
import style from './emoji-mart.css';

class EmojiPicker extends React.Component {
  constructor(props) {
    super(props);
    this.emojiPicker = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  handleClickOutside(evt) {
    evt.preventDefault();
    let node = ReactDOM.findDOMNode(this.emojiPicker.current);
    if (node && !node.contains(evt.target)) {
      this.props.closePicker();
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  render() {
    const { onSelectEmoji } = this.props;

    return (
      <Picker
        ref={this.emojiPicker}
        title="Pick your emoji…"
        emoji="hand"
        style={{ position: 'absolute', right: '0', top: '50px', zIndex: '999' }}
        onSelect={emoji => {
          onSelectEmoji(emoji);
        }}
        color="#aa1e23"
      />
    );
  }
}

export default compose(connect())(EmojiPicker);
